import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContentComponent } from './content/content.component';
import { HeaderComponent } from './header/header.component';
import { CcsThemeService } from './services/ccs-theme.service';

@Component({
  selector: 'app-ccs-module',
  templateUrl: './ccs-module.component.html',
  styleUrls: ['./ccs-module.component.scss']
})
export class CcsModuleComponent implements OnInit {
  @ViewChild(ContentComponent) contentComponent!: ContentComponent;
  @ViewChild(HeaderComponent) headerComponent!: HeaderComponent;

  constructor(
    private themeService: CcsThemeService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    // The theme service will initialize itself when injected
    
    // Check for query parameters to set active section
    this.route.queryParams.subscribe(params => {
      if (params['section']) {
        // If there are query parameters (e.g., returning from launch case), 
        // navigate to the specified section and override any default navigation
        setTimeout(() => {
          if (this.contentComponent && this.headerComponent) {
            this.contentComponent.setActiveSection(params['section']);
            
            // Update header title based on section
            if (params['section'] === 'interactive-cases') {
              this.headerComponent.currentTab = 'Interactive Cases';
            }
          }
        });
      }
      // If no query parameters, let the sidebar handle the default navigation to welcome page
    });
  }

  // Method to handle navigation from sidebar
  onNavigate(event: {section: string, title: string, data?: any}): void {
    // Update content view
    this.contentComponent.setActiveSection(event.section, event.data);
    // Update header title
    this.headerComponent.currentTab = event.title;
  }
}
